module.exports = __webpack_public_path__ + "img/actionImg7@2x.3fdc6998.jpg";